"use strict";
function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;
//# sourceMappingURL=_stackDelete.js.map